'use strict';


import { prepareMaterial } from '../autoProjectScript';
import { Mesh } from 'three';


export class ObjectCore {

  constructor (data,geometry,textureLoader) {
    const material = prepareMaterial(data.material.config,textureLoader,data.material.type);
    this.mesh = new Mesh(geometry,material);
    this.mesh.name = data.id;
    this.mesh.position.fromArray(data.position);
    this.mesh.rotation.fromArray(data.rotation);
    this.mesh.scale.fromArray(data.scale);
  }

  visibilityToggle(state) {
    this.mesh = state;
  }

}
